import { LobbyDetailComponentType } from "../view/screens/lobby/LobbyDetailComponentType";
import { AbstractLobbyDetailVO } from "./AbstractLobbyDetailVO";
import { TournamentInfoLineVO } from "./TournamentInfoLineVO";

export class TournamentLobbyDetailVO extends AbstractLobbyDetailVO {
    constructor() {
        CONSTRUCTOR_HACK;
        super();
        this.lobbyDetailType = 0;
    }

    /** Tournament id **/
    public id: number = 0;

    /** Tournament name **/
    public name: string;

    /** Tournament type id; 0: shootout, 1: freezeout etc. **/
    public type: number = 0;

    /** Start time **/
    public start: number = NaN;

    /** Player count **/
    public playerCount: number = 0;

    /** Id for unique item. -1 = no item **/
    public itemId: number = 0;

    /**
     *  Player state for this tournament
     *  0 = tournament not running, player is not registered
     *  1 = tournament not running, player is registered
     *  2 = tournament is running, player is not registered
     *  3 = tournament is running, player is registered
     *  4 = tournament is running, player is registered and player is disqualified
     **/
    public state: number = 0;

    /** Payout list. Contains table row data with these items: [rank,chips,gold] **/
    public payOut: TournamentInfoLineVO[];

    /** Rank of the player for this tournament **/
    public rank: number = NaN;

    /** Current chips pot **/
    public potChips: number = NaN;

    /** Current gold pot **/
    public potGold: number = NaN;

    /** Current gold pot **/
    public pointsMultiplier: number = NaN;

    public toString(): string {
        return super.toString() + ", id: " + this.id + ", name: " + this.name + ", type: " + this.type + ", start: " + this.start + ", cp: " + this.playerCount + ", itemId: " + this.itemId + ", state: " + this.state + ", payOut: " + this.payOut + ", rank: " + this.rank + ", potChips: " + this.potChips + ", potGold: " + this.potGold + ", pointsMultiplier: " + this.pointsMultiplier;
    }
}
